import FSEWithInfo from '../script/FSEWithInfo.js';
import { normaliserCarteVitale } from '../script/carteVitale.js';

export default {
    namespaced: true,
    state() {
        return {
            indexBenefActif : null,
            carteCPS: {},
            carteVitale: {},
            ErreurCodeCPS: false,
            nbTentativeDuCodeCPS : 3,
            codeCPS: null,
            structures_publiques_cartevitale: {
                VITALE_TYPE_CARTE: 0,
                VITALE_NUMERO_SERIE: 1,
                VITALE_DATE_FIN_VALIDITE: 2,
                VITALE_DONNEES_RUF1: 3,
                VITALE_DONNEES_RUF2: 4,
                VITALE_DONNEES_RUF: 5,
                VITALE_TYPE_IDENTIFICATION: 6,
                VITALE_NUMERO_IMMAT: 7,
                VITALE_CLE_MATRICULE: 8,
                VITALE_CODE_REGIME: 9,
                VITALE_CAISSE_GESTIONNAIRE: 10,
                VITALE_CENTRE_GESTIONNAIRE: 11,
                VITALE_CODE_GESTION: 12,
                VITALE_RUF_FAMILLE: 13,
                // valable dans les beneficiaires ... attention 3 eme bloc
                VITALE_NOM_PATRO: 1,
                VITALE_NOM_USUEL: 0,
                VITALE_PRENOM: 2,
                VITALE_ADRESSE: 3,
                VITALE_ADRESSE2: 4,
                VITALE_ADRESSE3: 5,
                VITALE_ADRESSE4: 6,
                VITALE_ADRESSE5: 7,
                VITALE_NIR_CERTIFIE: 8,
                VITALE_CLE_NIR_CERTIFIE: 9,
                VITALE_DATE_NIR_CERTIFIE: 10,
                VITALE_DATE_NAISSANCE: 11,
                VITALE_RANG_GEMELLAIRE: 12,
                VITALE_QUALITE: 13,
                VITALE_SERVICE_AMO: 14,
                VITALE_DEBUT_SERVICE_AMO: 15,
                VITALE_FIN_SERVICE_AMO: 16,
                VITALE_RUF_AMO: 17,
                // Différentes
                VITALE_COMPL_GARANTIES: 0,
                VITALE_NOMBRE_PERIODES_DROITS_AMO: 999,
                //  a tester
                VITALE_OUVERTURE_DROITS: 999,
                VITALE_ALD: 0,
                VITALE_SITUATION: 0,
                VITALE_COMPL_OUVERTURE_DROITS: 0,
                //
                VITALE_NO_BLOC_ASSURE: 101,
                VITALE_NO_BLOC_BENEFICIAIRE: 104,
                VITALE_TYPE_LECTURE: 2,
                //   MUT 107
                VITALE_MUT_IDENT: 0,
                VITALE_MUT_GARANTIES: 1,
                VITALE_MUT_INDICTRT: 2,
                VITALE_MUT_TYPSERVSTS: 3,
                VITALE_MUT_SERVICESSTS: 4,
                VITALE_MUT_AIGUILLAGESTS: 5,
                //  DRMUT 108
                VITALE_MUT_DEBUTDROITS: 0,
                VITALE_MUT_FINDROITS: 1,
                //   AMC COMPL 109
                VITALE_COMPL_COMPB2: 0,
                VITALE_COMPL_COMPEDI: 1,
                VITALE_COMPL_ADHERENT: 2,
                VITALE_COMPL_INDICTRT: 3,
                VITALE_COMPL_DEBUTVALID: 4,
                VITALE_COMPL_FINVALID: 5,
                VITALE_COMPL_ROUTAGE: 6,
                VITALE_COMPL_IDENTHOTE: 7,
                VITALE_COMPL_DOMAINE: 8,
                VITALE_COMPL_AIGUILLAGESTS: 9,
                VITALE_COMPL_TYPSERVSTS: 10,
                VITALE_COMPL_SERVICESSTS: 11,
                //   RUF COMPL 111
                VITALE_RUF_DONNEESBENEF: 0,
            }
        }
    }
    ,
    mutations: {
        setIndexBenefActif(state, newIndexBenefActif) {
            state.indexBenefActif = newIndexBenefActif;
        },
        setCarteCPS(state, carteCPS) {
            //alert(' setCarteCPS  Fin');
            state.carteCPS = carteCPS;
            FSEWithInfo.setCarteCPS(carteCPS);
        },

        setCarteVitale(state, carteVitale) {
            FSEWithInfo.setCarteVitale(carteVitale).then(response => {
                state.carteVitale = normaliserCarteVitale(response);
            });
        },

        // Carte deja construite cote backend (ApCV, ou mode test carte virtuelle) :
        // pas de POST SetVitale, mais MEME normalisation que setCarteVitale.
        setCarteVitaleDirect(state, carteVitale) {
            state.carteVitale = normaliserCarteVitale(carteVitale);
        },

        receiveDataFromXamarinObject(state, data) {
            alert('receiveDataFromXamarinObject Fin');
        },

        setErreurCodeCPS(state, boolError) {
            state.ErreurCodeCPS = boolError;
            alert("ErreurCodeCPS = " + state.ErreurCodeCPS);
        },
        setNbTentativeDuCodeCPS(state, newNbTentativeDuCodeCPS) {
            state.nbTentativeDuCodeCPS = newNbTentativeDuCodeCPS;
        },
        decrementerNbTentativeDuCodeCPS(state) {
            state.nbTentativeDuCodeCPS = state.nbTentativeDuCodeCPS - 1;
        }
    },

    actions: {
        setIndexBenefActif({ commit, state }, newIndexBenefActif) {
            commit('setIndexBenefActif', newIndexBenefActif);
        },
        setCarteCPS({ commit, state }, carteCPS) {
            commit('setCarteCPS', carteCPS);
        },
        setCarteVitale({ commit, state }, carteVitale) {
            commit('setCarteVitale', carteVitale);
        },
        setCarteVitaleDirect({ commit, state }, carteVitale) {
            commit('setCarteVitaleDirect', carteVitale);
        },
        receiveDataFromXamarinObject({ commit, state }, data) {
            commit('receiveDataFromXamarinObject', data);
        }
    },
    getters: {
        getIndexBenefActif(state) { return state.indexBenefActif },
        getNbTentativeDuCodeCPS(state) { return state.nbTentativeDuCodeCPS },
        getErreurCodeCPS(state) { return state.ErreurCodeCPS },
        getCarteCPS(state) {
            return state.carteCPS;
        },
        getCarteVitale(state) {
            return state.carteVitale;
        },
        getEnum(state) {
            return state.structures_publiques_cartevitale;
        },
        getStructures_publiques_cartevitale(state) {
            return state.structures_publiques_cartevitale;
        }
    },
}
